import React from 'react';
import PropTypes from 'prop-types';

import styles from '../../../../stylesheets/public/layouts/AboutPage.module.postcss';
import ResponsiveImg from '../../shared/ResponsiveImg';

function CtaImage({ image, alt = '', noLazy = false, isResponsive = false }) {
  return (
    <div className={styles.Cta_image}>
      { !isResponsive &&
        <img src={image} alt={alt} loading={noLazy ? 'eager' : 'lazy'} fetchpriority={noLazy ? 'high' : 'low'} />
      }

      { isResponsive &&
        <ResponsiveImg
          src={image}
          widths={[400, 600, 800, 1000]}
          // `.Section--extraPadding` has 24px horizontal padding on each side
          // below 732px, so the actual image container is (100vw - 48px).
          // Declaring `100vw` made the browser fetch the 800w variant on
          // Lighthouse's 412px mobile viewport when the real container is
          // only 364px wide — 60+ KiB of wasted payload per image.
          sizes='(max-width: 900px) calc(100vw - 48px), 550px'
          alt={alt}
          loading={noLazy ? 'eager' : 'lazy'}
          fetchpriority={noLazy ? 'high' : 'low'}
          width={550}
          height={367}
        />
      }
    </div>
  );
}

CtaImage.propTypes = {
  image: PropTypes.string.isRequired,
  alt: PropTypes.string,
};

export default CtaImage;
